import { render, staticRenderFns } from "./ErpGateway.vue?vue&type=template&id=22c888ec"
import script from "./ErpGateway.vue?vue&type=script&lang=js"
export * from "./ErpGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports